import "./styles.css";
import { Grid } from "@mui/material";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import {
  clearLocalStorageData,
  getLocalStorageData,
  removeLocalStorageData,
  setLocalStorageData,
} from "../../../../shared/utils/localStorage";
import { LoadingButton } from "@mui/lab";
import InputTextfield from "../../../../shared/components/textField";
import { getValidationSchema } from "../../../../shared/validations/schema";
import LoginUI from "../../../../shared/components/loginUI";
import { useContext, useEffect, useState } from "react";
import { SnackBarAlertContext } from "../../../../contexts/SnackbarContext";
const App = () => {
  const { id } = useParams();
  setLocalStorageData("token", id);
  const snackBarAlertContext = useContext(SnackBarAlertContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const redirectUrl = `${process.env.REACT_APP_GLOBAL_AUTH_CLIENT_FRONTEND}/reset-password/${id}`;
      window.location.href = redirectUrl;
    }
  }, []);

  const textFields = [
    {
      id: "login-new-password",
      name: "newPassword",
      label: "New Password",
      placeholder: "Enter new password",
      type: "password",
    },
    {
      id: "login-confirm-password",
      name: "confirmPassword",
      label: "Confirm Password",
      placeholder: "Confirm new password",
      type: "password",
    },
  ];

  const passwordResetForm = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: getValidationSchema(["newPassword", "confirmPassword"]),
    onSubmit: async (formData: any) => {
      const token = getLocalStorageData("token");
      setLoading(true);
      fetch(
        `${process.env.REACT_APP_LOGIN_GCOM_UNIFIED_API_URL}/user/reset-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            password: formData.newPassword,
          }),
        }
      ).then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json();
          snackBarAlertContext.set({
            status: true,
            type: "error",
            message: errorData?.message || "Something went wrong",
          });
        } else {
          const responseData = await response.json();
          snackBarAlertContext.set({
            status: true,
            type: "success",
            message: responseData?.message || "Reset link sent successfully",
          });
          clearLocalStorageData();

          navigate("/");
        }
        setLoading(false);
      });
    },
  });

  return (
    <></>
    // <LoginUI
    //   title="Set password"
    //   reactElement={
    //     <div className="loginGridContainerReset">
    //       <form
    //         onSubmit={passwordResetForm.handleSubmit}
    //         autoComplete="off"
    //         className="resetPasswordForm"
    //       >
    //         {textFields.map((field: any, index: number) => {
    //           return (
    //             <InputTextfield
    //               key={index}
    //               form={passwordResetForm}
    //               className="mediumInputBoxReset"
    //               fieldProps={field}
    //               information="Password must contain at least 8 character, including upper case, lower case, numeric value and special character"
    //             />
    //           );
    //         })}
    //         <Grid container justifyContent="flex-end">
    //           <Grid item md={8}>
    //             <LoadingButton
    //               className="signInButtonReset"
    //               loading={loading}
    //               variant="contained"
    //               type="submit"
    //               fullWidth
    //               size="small"
    //             >
    //               Set Password
    //             </LoadingButton>
    //           </Grid>
    //         </Grid>
    //       </form>
    //     </div>
    //   }
    // />
  );
};

export default App;
